/**
 * ManageChannels template.
 */
import Animator from '@components/elements/animator/animator';
import Bold from '@components/atoms/text/bold';
import Button from '@components/elements/buttons/ui/genericButton';
import ChannelList from '@components/sections/list/channelList/channelList';
import ChannelListContentContainer from '@components/atoms/container/channelListContentContainer';
import List from '@components/sections/list/list';
import ManageChannelContext from '@shared/components/utils/context/manageChannelsContext';
import ManageChannelsButtonsContainer from '@components/atoms/container/manageChannelsButtonContainer';
import ManageChannelsInfoContainer from '@components/atoms/container/manageChannelsInfoContainer';
import ManageChannelsText from '@components/atoms/text/manageChannelsText';
import useManageChannelsTemplate from '../lib/useManageChannelsTemplate';
import { selectMenuCollapse } from '@shared/store/slices/menu.slice';
import { useAppSelector } from '@shared/store/hooks';

/**
 * ManageChannels template component.
 */
export default function ManageChannelsTemplate() {
  const { display, props, literals, context } = useManageChannelsTemplate();
  const menuExpanded = !useAppSelector(selectMenuCollapse);
  return (
    <ManageChannelContext.Provider value={context}>
      <Animator
        id={'manageChannelsContainer'}
        type={Animator.Type.SETTING}
        collapse={{ horizontal: menuExpanded }}
      >
        <ChannelListContentContainer>
          {display ? <ChannelList {...props.channelList} /> : <></>}
        </ChannelListContentContainer>
        <ManageChannelsInfoContainer>
          <ManageChannelsText>
            <Bold>{literals.order}</Bold>
            <br></br>
            {literals.pressOk}
            <br></br>
            {literals.move}
            <br></br>
            {literals.pressOkToFix}
            <br></br>
            {literals.finish}
          </ManageChannelsText>
          <ManageChannelsButtonsContainer {...props.buttonsContainer}>
            <List {...props.buttonList}>
              <Button {...props.acceptButton} />
              <Button {...props.restoreButton} />
              <Button {...props.cancelButton} />
            </List>
          </ManageChannelsButtonsContainer>
        </ManageChannelsInfoContainer>
      </Animator>
    </ManageChannelContext.Provider>
  );
}
